<template>
    <v-dialog 
        class="px-1 py-1"
        v-model="dialog"
        width="30vw"
        persistent>
        <v-card class="pt-3 pb-5 px-5">
            <v-card-title class="pb-0 justify-center text-center align-center">
                Welcome to the Matador Forecasting Tool
            </v-card-title>
            <v-card-text class="text-center justify-center align-center">
                To continue, please enter your name:
                <v-text-field 
                    v-model="name"
                    label="Name"/>
            </v-card-text>
            <v-row class="d-flex justify-center align-center">
                <v-btn
                    :disabled="checkName"
                    @click="saveName"
                    color="primary">
                    Submit
                </v-btn>
            </v-row>
        </v-card>
  </v-dialog>
</template>

<script>
export default {
    beforeMount() {
        if (!localStorage.username) {
            this.dialog = true
        } else {
            this.name = localStorage.username
        }
    },
    data() {
        return {
            name: '',
            dialog: '',
        }
    },
    methods: {
        saveName() {
            localStorage.username = this.name
            this.dialog = false
        }
    },
    computed: {
        checkName() {
            if (this.name.length > 2) {
                return false
            } else {
                return true
            }
        }
    }
}
</script>

<style>

</style>